var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-4 mb-4 border-box"},[_c('span',{staticClass:"font-weight-light"},[_vm._v("Tisch: ")]),_c('span',{staticClass:"font-weight-black"},[_vm._v("Tisch "+_vm._s(_vm.sofortbestellung.tischBezeichnung))])])
}
var staticRenderFns = []

export { render, staticRenderFns }